import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    POST: "سمت",
    DEGREE: "گواهینامه",
    FIELD: "فارغ‌التحصیل رشته",
    TELL: "شماره تلفن",
    PLACE: "مکان",
  },
  [LOCALES.EN]: {
    POST: "Position",
    DEGREE: "Certificate",
    FIELD: "Graduated in",
    TELL: "Phone",
    PLACE: "Place",
  },
} as const;

export default translation;
